import { FC } from 'react';

import DIContainerProvider from 'application/providers/DIContainerProvider';
import DataProvider from 'application/providers/DataProvider';
import StoreProvider from 'application/providers/StoreProvider';
import AppInitializer from 'application/providers/AppInitializer';
import NotificationProvider from 'application/providers/NotificationProvider';
import GTMWrapper from 'application/components/GTMWrapper';
import SupportChat from 'application/components/widgets/SupportChat';

import { MediaQueriesProvider } from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import ApplicationRouter from './Application';

const Main: FC = () => (
  <DataProvider>
    <DIContainerProvider>
      <StoreProvider>
        <AppInitializer>
          <MediaQueriesProvider>
            <NotificationProvider>
              <ApplicationRouter />
            </NotificationProvider>
          </MediaQueriesProvider>
          <SupportChat />
        </AppInitializer>
      </StoreProvider>
    </DIContainerProvider>
    <GTMWrapper />
  </DataProvider>
);

export default Main;
